const o = "_content_o1r2h_2", t = "_arrow_o1r2h_12", n = {
  content: o,
  arrow: t
};
export {
  t as arrow,
  o as content,
  n as default
};
//# sourceMappingURL=Tooltip.module.css.js.map
